<template>
  <div class="sec_banner">
    <!-- <div class="flexslider">
      <ul class="slides"></ul>
    </div> -->
    <el-carousel height="209px" v-if="bannerList.length > 0">
      <el-carousel-item
        class="banner-item"
        v-for="{ id, img, type, content } in bannerList"
        :key="id"
      >
        <div class="banner-wrapper" @click="getBannerUrl(type, content, id)">
          <img class="banner-img" :src="img" />
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  created() {
    this.getBanners();
  },
  data() {
    return { bannerList: [] };
  },
  methods: {
    async getBanners() {
      const bannerList = await this.$http.getBanners();
      this.bannerList = bannerList;
      console.log({ bannerList });
    },
    getBannerUrl(type, url, id) {
      if (!url) return;
      switch (type) {
        case 1:
        case 3:
          url && window.open(url);
          break;
        case 2:
          window.location.href = `/HEU/bannerDetail/bannerDetail.html?bannerCon=${id}`;
        default:
          break;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.banner-item {
  .banner-wrapper {
    height: 100%;
  }
  .banner-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>